import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronRight, FiCheck, FiX } = FiIcons;

export default function Messages() {
  const {
    chats = [], receivedRequests = [], users = [],
    friends = [], acceptRequest, rejectRequest, getOrCreateChat
  } = useAppContext();
  const navigate = useNavigate();

  const validRequests = receivedRequests.filter(id => !friends.includes(id));
  const validChats = chats.filter(chat => friends.includes(chat.user?.id));

  const handleAccept = (userId) => {
    acceptRequest(userId);
    // Navigate to chat after accept — getOrCreateChat returns existing or new id
    setTimeout(() => {
      const chat = chats.find(c => c.user?.id === userId);
      if (chat) navigate(`/messages/${chat.id}`);
    }, 50);
  };

  return (
    <div className="max-w-3xl mx-auto bg-white dark:bg-dark-surface min-h-[calc(100vh-64px)] border-x border-gray-100 dark:border-dark-border sm:my-6 sm:rounded-2xl sm:shadow-sm sm:min-h-0 sm:h-[80vh] flex flex-col overflow-hidden pb-20 sm:pb-0 transition-colors">
      <div className="p-4 border-b border-gray-100 dark:border-dark-border bg-white dark:bg-dark-surface sticky top-0 z-10 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white uppercase tracking-tight">Messages</h1>
      </div>

      <div className="flex-1 overflow-y-auto custom-scrollbar">
        {validRequests.length > 0 && (
          <div className="bg-brand-50/50 dark:bg-brand-900/10 p-4 border-b border-brand-100 dark:border-brand-900/30">
            <h3 className="text-[10px] font-black text-brand-600 dark:text-brand-400 uppercase tracking-[0.2em] mb-3 px-2">
              Pending Requests
            </h3>
            <div className="space-y-2">
              {validRequests.map(reqId => {
                const user = users.find(u => u.id === reqId);
                if (!user) return null;
                return (
                  <div key={user.id} className="bg-white dark:bg-dark-card p-3 rounded-2xl border border-brand-100 dark:border-brand-900/30 flex items-center justify-between shadow-sm">
                    <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate(`/profile/${user.id}`)}>
                      <img src={user.avatar} className="w-10 h-10 rounded-xl object-cover" alt="" />
                      <div>
                        <p className="text-sm font-black text-brand-950 dark:text-white uppercase tracking-tight">{user.nickname}</p>
                        <p className="text-[10px] text-gray-400 dark:text-dark-muted font-bold uppercase">Wants to be your Nakama</p>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleAccept(user.id)}
                        className="p-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition-colors shadow-md shadow-brand-100 dark:shadow-brand-900/20"
                      >
                        <SafeIcon icon={FiCheck} />
                      </button>
                      <button
                        onClick={() => rejectRequest(user.id)}
                        className="p-2 bg-gray-100 dark:bg-dark-border text-gray-400 hover:text-red-500 rounded-lg transition-colors"
                      >
                        <SafeIcon icon={FiX} />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {validChats.length === 0 && validRequests.length === 0 ? (
          <div className="p-8 text-center text-gray-500 flex flex-col items-center justify-center h-full">
            <p className="font-black uppercase text-xs tracking-widest text-gray-400 dark:text-dark-muted">No messages yet.</p>
            <p className="text-[10px] uppercase tracking-widest mt-2 text-gray-300 dark:text-gray-600">Find players in Discovery to start chatting!</p>
          </div>
        ) : (
          validChats.map(chat => (
            <div
              key={chat.id}
              onClick={() => navigate(`/messages/${chat.id}`)}
              className="group flex items-center gap-4 p-4 border-b border-gray-50 dark:border-dark-border hover:bg-brand-50/30 dark:hover:bg-dark-card cursor-pointer transition-all"
            >
              <div className="relative shrink-0">
                <img src={chat.user?.avatar} alt="" className="w-14 h-14 rounded-full object-cover border-2 border-transparent group-hover:border-brand-200" />
                {chat.unread > 0 && (
                  <span className="absolute top-0 right-0 w-4 h-4 bg-brand-600 border-2 border-white dark:border-dark-surface rounded-full flex items-center justify-center">
                    <span className="w-1.5 h-1.5 bg-white rounded-full animate-ping"></span>
                  </span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-baseline mb-0.5">
                  <h3 className={`truncate font-black uppercase tracking-tight text-xs ${chat.unread > 0 ? 'text-brand-950 dark:text-white' : 'text-gray-700 dark:text-gray-300'}`}>
                    {chat.user?.nickname}
                  </h3>
                  <span className="text-[10px] text-gray-400 dark:text-dark-muted font-bold uppercase tracking-widest ml-2">{chat.time}</span>
                </div>
                <p className={`text-sm truncate ${chat.unread > 0 ? 'font-bold text-brand-600' : 'text-gray-500 dark:text-gray-400'}`}>
                  {chat.lastMessage}
                </p>
              </div>
              <SafeIcon icon={FiChevronRight} className="text-gray-300 dark:text-gray-700 group-hover:text-brand-400 w-5 h-5 transition-colors" />
            </div>
          ))
        )}
      </div>
    </div>
  );
}